import { Flex, Text } from '@chakra-ui/react'
import { Button } from '../../../../../../components/Button'
import { ModalBase } from '../../../../../../components/ModalBase'

interface iModalComunicacao{
  isOpen: boolean
  onClose: () => void
}

export const ModalTag: React.FC<iModalComunicacao> = ({ isOpen, onClose }) => {
  return (
        <ModalBase Titulo='Como utilizar as TAGs' isOpen={isOpen} onClose={onClose} >
            <Flex maxWidth={'53.125rem'} borderTop={'1px solid var(--Gray4)'} borderBottom={'1px solid var(--Gray4)'} padding={'1rem'}>
                <Text>
                    Para deixar seus e-mails com uma cara mais personalizada nós criamos algumas TAGs que podem lhe ajudar.
                    <br/>
                    <br/>
                    Todos os e-mails devem conter a TAG <strong>[LINK]</strong> onde o respondente irá clicar para acessar a pesquisa, caso você não insira essa TAG o link será apresentado ao final do e-mail.
                    <br/>
                    <br/>
                    Você também pode personalizar com o nome da empresa, utilizando a TAG <strong>[NOME DA EMPRESA]</strong>
                    <br/>
                    <br/>
                    Outras TAGs que podem ser utilizadas são <strong>[DATA INICIO]</strong> e <strong>[DATA FIM]</strong>.
                    <br/>
                    <br/>
                    <strong>Não se esqueça que as TAGs devem ser sempre inseridas entre colchetes [ ], conforme estão escritas no texto acima.</strong>
                    <br/>
                </Text>
            </Flex>
            <Flex padding={'1rem'} justifyContent={'center'} alignItems={'center'}>
                <Button onClick={onClose} size={'lg'} VarColor='Green2'>Ok</Button>
            </Flex>
        </ModalBase>
  )
}
